import { QRCodeSVG } from "qrcode.react";
import { useSite } from "../context/SiteContext";

export default function OnlyFans() {
  const { content } = useSite();
  const url =
    content.onlyfans_url ||
    content.onlyfans ||
    "https://onlyfans.com/camilla.xxx?rec=485728775";
  const handle = content.handle || "camilla.xxx";
  return (
    <section id="onlyfans" className="section" data-testid="onlyfans-section">
      <div className="container-x px-5 md:px-8">
        <div className="card-luxe p-8 md:p-14 grid md:grid-cols-[auto_1fr] gap-10 items-center">
          <div
            className="p-4 bg-[#f4ede4] rounded-xl mx-auto"
            data-testid="onlyfans-qr"
          >
            <QRCodeSVG
              value={url}
              size={188}
              bgColor="#f4ede4"
              fgColor="#0a0a0a"
              level="M"
              includeMargin={false}
            />
          </div>
          <div className="text-center md:text-left">
            <div className="eyebrow mb-4 md:justify-start justify-center md:mx-0 mx-auto">
              OnlyFans
            </div>
            <h2 className="font-display text-4xl md:text-6xl text-gold leading-tight mb-4">
              Can't get enough?{" "}
              <span className="italic text-ivory">Come play on OnlyFans 💋</span>
            </h2>
            <p className="text-ivory-dim text-base md:text-lg mb-3 max-w-xl">
              Daily uncensored content, custom videos, sexting one-on-one, dick
              ratings, live streams, exclusive photo sets — everything I can't
              post here.
            </p>
            <p className="text-gold-2 text-sm tracking-wider mb-6 font-mono">
              onlyfans.com/{handle}
            </p>
            <a
              href={url}
              target="_blank"
              rel="noopener noreferrer"
              className="btn-gold shimmer-btn"
              data-testid="onlyfans-cta"
              onClick={() => { try { require("../lib/analytics").trackOf("of_section"); } catch {} }}
            >
              Follow @{handle} 🔥
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
